<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    :title="title"
    @shown="onModalOpened"
    @hidden="shown = false"
    size="lg"
  >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Filter code:"
      >
        <div class="templateEditor" ref="editor">
          <codemirror
            v-if="shown"
            :value="code"
            :options="cmOptions"
            @input="onCmCodeChange"
            @keydown.ctrl.83.native.prevent="save"
          />
        </div>
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'

export default {
  props: ['gridId', 'widgetKey', 'options'],
  data () {
    return {
      cellKey: null,
      shown: false,
      code: '',
      cmOptions: {
        tabSize: 2,
        styleActiveLine: false,
        lineNumbers: true,
        styleSelectedText: false,
        line: true,
        foldGutter: true,
        gutters: [
          'CodeMirror-linenumbers',
          'CodeMirror-foldgutter'
        ],
        highlightSelectionMatches: {
          showToken: /\w/,
          annotateScrollbar: true
        },
        hintOptions: {
          completeSingle: false
        },
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: true,
        extraKeys: {
          'Ctrl': 'autocomplete'
        },
        mode: 'text/javascript'
      }
    }
  },
  computed: {
    title () {
      return `Add filter to "${this.cellKey}" LookUp column`
    }
  },
  methods: {
    openModal () {
      if (this.$refs.modal) {
        this.$refs.modal.show()
      }
    },
    closeModal () {
      if (this.$refs.modal) {
        this.$refs.modal.hide()
      }
    },
    onModalOpened () {
      this.shown = true
      setTimeout(() => {
        const textarea = $(this.$refs.editor).find('textarea').get(1)
        $(textarea).focus()
      }, 100)
    },
    onCmCodeChange (code) {
      this.code = code
    },
    async save () {
      const data = {
        gridId: this.gridId,
        oName: `meta/${this.cellKey}/filterCode`,
        oValue: this.code || null,
      }

      await db.dataGrid.options.saveOption(data, () => {
        this.code = ''
        this.closeModal()
      })
    }
  },
  created () {
    eventBus.$on(`showLookUpFilter${this.widgetKey}-${this.gridId}`, (cellKey) => {
      this.cellKey = cellKey
      this.code = this.options.meta[this.cellKey].filterCode || ''
      this.openModal()
    })
  },
  mounted () {
    if (this.$refs.modal) {
      $(this.$refs.modal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.modal) {
      $(this.$refs.modal['$el']).remove()
    }
  }
}
</script>
